module.exports = __webpack_public_path__ + "img/18_46.4fea018c.png";